import { ProductLineCodesTypes } from '@cemex-core/cmx-api/models/business-lines/product-lines-codes';
import { swapMapKeyVal } from '../utils/swap-map';

export enum PRODUCT_LINE_CODE {
  BULK_CEMENT = '0001',
  BAG_CEMENT = '0002',
  MULTI_PRODUCT = '0003',
  BAG_CEMENT_AND_MULTI_PRODUCT = '0002,0003',
  AGGREGATES = '0005',
  READY_MIX = '0006',
  ADMIXTURES = '0014',
}

export enum PRODUCT_LINE_ALPHA_CODE {
  BULK_CEMENT = 'BKCM',
  BAG_CEMENT = 'BGCM',
  MULTI_PRODUCT = 'MLTP',
  BAG_CEMENT_AND_MULTI_PRODUCT = 'BGCM, MLTP',
  AGGREGATES = 'AGGR',
  READY_MIX = 'RDMX',
  ADMIXTURES = 'ADMX',
}

export const productLineCodeToAlphaMap = new Map<ProductLineCodesTypes, PRODUCT_LINE_ALPHA_CODE>([
  [PRODUCT_LINE_CODE.BULK_CEMENT, PRODUCT_LINE_ALPHA_CODE.BULK_CEMENT],
  [PRODUCT_LINE_CODE.BAG_CEMENT, PRODUCT_LINE_ALPHA_CODE.BAG_CEMENT],
  [PRODUCT_LINE_CODE.BAG_CEMENT_AND_MULTI_PRODUCT, PRODUCT_LINE_ALPHA_CODE.BAG_CEMENT_AND_MULTI_PRODUCT],
  [PRODUCT_LINE_CODE.MULTI_PRODUCT, PRODUCT_LINE_ALPHA_CODE.MULTI_PRODUCT],
  [PRODUCT_LINE_CODE.AGGREGATES, PRODUCT_LINE_ALPHA_CODE.AGGREGATES],
  [PRODUCT_LINE_CODE.READY_MIX, PRODUCT_LINE_ALPHA_CODE.READY_MIX],
  [PRODUCT_LINE_CODE.ADMIXTURES, PRODUCT_LINE_ALPHA_CODE.ADMIXTURES],
]);

export enum PRODUCT_LINE_NAME_CODE {
  READYMIX = 'RMX',
  CEMENT = 'CEM',
  AGGREGATES = 'AGG',
  MULTIPRODUCT = 'MLT',
  ADMIXTURES = 'ADT',
}

export const productLineCodeToNameMap = new Map<ProductLineCodesTypes, PRODUCT_LINE_NAME_CODE>([
  [PRODUCT_LINE_CODE.BULK_CEMENT, PRODUCT_LINE_NAME_CODE.CEMENT],
  [PRODUCT_LINE_CODE.BAG_CEMENT, PRODUCT_LINE_NAME_CODE.CEMENT],
  [PRODUCT_LINE_CODE.READY_MIX, PRODUCT_LINE_NAME_CODE.READYMIX],
  [PRODUCT_LINE_CODE.AGGREGATES, PRODUCT_LINE_NAME_CODE.AGGREGATES],
  [PRODUCT_LINE_CODE.MULTI_PRODUCT, PRODUCT_LINE_NAME_CODE.MULTIPRODUCT],
  [PRODUCT_LINE_CODE.ADMIXTURES, PRODUCT_LINE_NAME_CODE.ADMIXTURES],
]);

export type ProductLineNameCodesTypes =
  | PRODUCT_LINE_NAME_CODE.READYMIX
  | PRODUCT_LINE_NAME_CODE.CEMENT
  | PRODUCT_LINE_NAME_CODE.AGGREGATES
  | PRODUCT_LINE_NAME_CODE.MULTIPRODUCT
  | PRODUCT_LINE_NAME_CODE.ADMIXTURES;

export const productLineNameToCodeMap = swapMapKeyVal(productLineCodeToNameMap);

export const transformProductLineNameToCode = (productLineName: PRODUCT_LINE_NAME_CODE) => {
  return productLineNameToCodeMap.get(productLineName);
};

/**
 * Enum representing the icons associated with different product lines.
 * Each product line is mapped to a specific icon class name.
 *
 * @enum {string}
 */
export enum PRODUCT_LINE_ICONS {
  READY_MIX = 'product-line-readymix',
  BAG_CEMENT = 'product-line-bag-cement',
  BAG_CEMENT_AND_MULTI_PRODUCT = 'product-line-bag-multiproduct',
  BULK_CEMENT = 'product-line-bulk-cement',
  MULTI_PRODUCT = 'product-line-multiproducts',
  AGGREGATES = 'product-line-aggregates',
  BULK_ADMIXTURES = 'product-line-admixtures',
}

/**
 * Enum representing the icons associated with different shipping conditions.
 * Each shipping condition is mapped to a specific icon class name.
 * There is no icon designed for STANDARD yet.
 *
 * @enum {string}
 */
export enum SHIPPING_CONDITION_ICONS {
  DELIVERY = 'options-delivery',
  PICK_UP = 'options-pickup',
  OWN_FREIGHT = 'options-own-freight',
  STANDARD = '',
  NONE = '',
}
